<template>
  <div>
    <el-card>
      <div style="font-size: 14px; color: #606266;">
        <span>No：{{ formData.userTripRequestNo }}</span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.userTripRequestStatus === 'N'
              ? 'primary'
              : formData.userTripRequestStatus === 'S'
              ? 'warning'
              : formData.userTripRequestStatus === 'Y'
              ? 'success'
              : formData.userTripRequestStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{
            formData.v_userTripRequestStatus ||
              $l('INDEX.form_label_status_draft') ||
              '草稿'
          }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span
          >Create：{{ formData.createByName }} at
          {{ formData.createTime }}</span
        >
        <el-divider direction="vertical"></el-divider>
        <span
          >Modify：{{ formData.modifyByName }} at
          {{ formData.modifyTime }}</span
        >
      </div>
      <div class="d2-mt">
        <el-form ref="form" size="mini" :model="formData" :rules="rules">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_requestDate') || '申请日期'"
                prop="requestDate"
              >
                <el-date-picker
                  size="mini"
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                  clearable
                  v-model="formData.requestDate"
                  :picker-options="requestDatePicker"
                  type="date"
                  :disabled="disabled"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_tripStartDate') || '出差起始日'"
                prop="tripStartDate"
              >
                <el-date-picker
                  size="mini"
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                  clearable
                  v-model="formData.tripStartDate"
                  :picker-options="tripStartDatePicker"
                  type="date"
                  :disabled="disabled"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_tripEndDate') || '出差终止日'"
                prop="tripEndDate"
              >
                <el-date-picker
                  size="mini"
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                  clearable
                  v-model="formData.tripEndDate"
                  :picker-options="tripEndDatePicker"
                  type="date"
                  :disabled="disabled"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$l('form_label_tripDays') || '出差天数'">
                <el-input v-model="tripDays" readonly> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="3">
              <el-form-item
                :label="$l('form_label_tripStartTime') || '出发时间'"
                prop="tripStartTime"
              >
                <el-time-select
                  v-model="formData.tripStartTime"
                  :picker-options="{
                    start: '00:00',
                    step: '00:01',
                    end: '23:59',
                  }"
                  style="width: 100%"
                  :disabled="disabled"
                >
                </el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item
                :label="$l('form_label_tripEndTime') || '返回时间'"
                prop="tripEndTime"
              >
                <el-time-select
                  v-model="formData.tripEndTime"
                  :picker-options="{
                    start: '00:00',
                    step: '00:01',
                    end: '23:59',
                  }"
                  style="width: 100%"
                  :disabled="disabled"
                >
                </el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('table_label_departure_city_name') || '出差起始地'"
                prop="departureCityCode"
              >
                <dict-select
                  v-model="formData.departureCityCode"
                  url="/master/common/dict/biz"
                  :body="tripCityParams"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  size="mini"
                  style="width: 100%"
                  filterable
                  clearable
                  :selectedLabel.sync="formData.departureCityName"
                  :disabled="disabled"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$l('table_label_destination_city_name') || '出差目的地'"
                prop="destinationCityCode"
              >
                <el-input
                  clearable
                  v-model="formData.destinationCityName"
                  :placeholder="
                    $l('form_label_Please_add_schedule') || '请增加行程计划'
                  "
                  size="mini"
                  type="text"
                  readonly
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_cashAdvances') || '暂支旅费'"
                prop="cashAdvances"
              >
                <el-input-number
                  v-model="formData.cashAdvances"
                  style="width:100%"
                  :min="0"
                  :max="1000000000"
                  :precision="2"
                  :step="1"
                  controls-position="right"
                  size="mini"
                  :disabled="disabled"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_tripRemark') || '备注'">
                <el-input
                  v-model="formData.tripRemark"
                  :placeholder="
                    $l('form_label_please_enter_tripRemark') || '请输入备注'
                  "
                  clearable
                  type="textarea"
                  maxlength="500"
                  show-word-limit
                  :autosize="{ minRows: 3, maxRows: 3 }"
                  :disabled="disabled"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <ScheduleTable
              :disabled="disabled"
              :userTripRequestCode="userTripRequestCode"
              :tripStartDate="this.formData.tripStartDate"
              :tripEndDate="this.formData.tripEndDate"
              @updateDestinationCityName="updateDestinationCityName"
              ref="schedule"
            />
          </el-row>
        </el-form>
      </div>
      <div class="d-flex justify-content-end mt-3 mb-2" v-if="!disabled">
        <el-button type="primary" size="small" @click="save()">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ScheduleTable from '../schedule-table/table'
import dayjs from 'dayjs'
export default {
  name: 'personal-myTravelDetail',
  mixins: [EditLoading],
  components: { ScheduleTable },
  computed: {
    params() {
      return this.$route.params
    },
    userTripRequestCode() {
      return this.params.code
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    disabled() {
      return this.pageType === 'detail'
    },
    ...mapState('admin/user', ['info']),
    tripDays: {
      get() {
        const { tripStartDate, tripEndDate, tripStartTime } = this.formData

        if (tripStartDate && tripEndDate) {
          var stime = Date.parse(new Date(this.formData.tripStartDate))
          var etime = Date.parse(new Date(this.formData.tripEndDate))
          // 两个时间戳相差的毫秒数
          var usedTime = etime - stime
          var day = 0
          if (usedTime > 0) {
            // 计算相差的天数
            day = Math.floor(usedTime / (24 * 3600 * 1000))
          }
          if (tripStartTime) {
            return tripStartTime.split(':')[0] < 14 || tripStartTime === '14:00'
              ? day + 1
              : day
          }
        }
        return day
      },
      set() {},
    },
  },
  data() {
    return {
      requestDatePicker: this.requestDateEnd(),
      formData: {
        destinationCityName: '',
        destinationCityCode: '',
        cashAdvances: 0,
        tripEndTime: '18:00',
        tripStartTime: '10:00',
        requestDate: dayjs(new Date()).format('YYYY-MM-DD'),
      },
      tripCityParams: { dictType: 'tripCity' },
      tripStartDatePicker: this.tripEndDate(),
      tripEndDatePicker: this.tripStartDate(),
      rules: {
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        tripStartDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        tripEndDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        tripStartTime: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        tripEndTime: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        // cashAdvances: [
        //   {
        //     required: true,
        //     message: this.$l('INDEX.tips_input_placeholder') || '请输入',
        //     trigger: 'blur'
        //   }
        // ],
        departureCityCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        // destinationCityCode: [
        //   {
        //     required: true,
        //     message: this.$l('INDEX.tips_input_placeholder') || '请输入',
        //     trigger: 'blur'
        //   }
        // ],
        tripReasons: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        tripPurpose: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    requestDateEnd() {
      return {
        disabledDate(time) {
          //如果结束时间不为空，则小于结束时间
          return new Date().getTime() < time.getTime()
        },
      }
    },
    getData() {
      if (this.userTripRequestCode) {
        this.$api
          .userTripRequestDetailApi({
            userTripRequestCode: this.userTripRequestCode,
          })
          .then((res) => {
            this.formData = res.body
          })
      }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      //校验行程计划
      const scheduleList = await this.$refs.schedule.getTableData()
      if (!scheduleList || scheduleList.length == 0) {
        this.$message.warning(
          this.$l('form_label_Please_save_after_adding_journey') ||
            '请增加行程后保存'
        )
        return
      }
      //校验行程计划列表中的时间

      var stime = Date.parse(new Date(this.formData.tripStartDate))
      var etime = Date.parse(new Date(this.formData.tripEndDate))

      for (const data of scheduleList) {
        var scheduleStartDate = Date.parse(new Date(data.scheduleStartDate))
        var scheduleEndDate = Date.parse(new Date(data.scheduleEndDate))
        if (
          scheduleStartDate > etime ||
          scheduleStartDate < stime ||
          scheduleEndDate > etime ||
          scheduleEndDate < stime
        ) {
          this.$message.warning(
            this.$l('tips_travel_plan_date_exceeds_form_date') ||
              '行程计划日期超过申请单日期范围，请检查后重试'
          )
          return
        }
      }

      this.formData.salesPersonCode = this.info.userCode
      this.formData.salesPersonName =
        (this.info.userNameEn ? this.info.userNameEn + '-' : '') +
        this.info.userName
      this.formData.tripDays = this.tripDays
      this.formData.scheduleList = scheduleList
      this.loadingOpen()
      this.$api
        .userTripRequestSaveApi({
          ...this.formData,
          tripStartTime:
            this.formData.tripStartDate +
            ' ' +
            this.formData.tripStartTime +
            ':00',
          tripEndTime:
            this.formData.tripEndDate + ' ' + this.formData.tripEndTime + ':00',
        })
        .then(() => {
          this.loadingClose()
          this.saveOkQuestion()
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
    updateDestinationCityName(destinationCityName, destinationCityCode) {
      this.formData.destinationCityName = destinationCityName
      this.formData.destinationCityCode = destinationCityCode
    },
    tripStartDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.tripStartDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.formData.tripStartDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    tripEndDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.tripEndDate) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.formData.tripEndDate).getTime() < time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
